import { useCallback } from 'react';

import { POLYGON_EVENTS } from '../lib';
import { FILTERS } from '../../../constants';

const useDrawable = (
  mapInstance,
  polygonTogglerState,
  setPolygonTogglerState,
  setIsPolygonDrawing,
  clearPolygon,
  saveLocationBeforePolygon,
  getSavedLocation,
  markPolygonAction,
  navigate,
) => {
  const { IDLE, DRAWING, DRAWN } = POLYGON_EVENTS;

  return useCallback(() => {
    const { pathname, search } = navigate.location;
    const searchParams = new URLSearchParams(search);

    if (polygonTogglerState === IDLE) {
      const mapBounds = mapInstance?.getBounds();

      saveLocationBeforePolygon({ pathname, search, mapBounds });
      setIsPolygonDrawing(true);
      setPolygonTogglerState(DRAWING);

      return;
    }

    if (polygonTogglerState === DRAWN) {
      searchParams.delete(FILTERS.IDS.POLYGON_LOCATION);

      navigate.push({
        pathname,
        search: searchParams.toString() ? `?${searchParams.toString()}` : '',
      });

      clearPolygon();
      setPolygonTogglerState(IDLE);
      setIsPolygonDrawing(false);
      markPolygonAction();

      return;
    }

    if (polygonTogglerState === DRAWING) {
      searchParams.delete(FILTERS.IDS.POLYGON_LOCATION);

      const saved = getSavedLocation() || { pathname, search };

      navigate.push({
        pathname: saved.pathname,
        search: saved.search,
      });

      clearPolygon();
      setIsPolygonDrawing(false);
      setPolygonTogglerState(IDLE);
    }
  }, [
    navigate,
    polygonTogglerState,
    IDLE,
    DRAWN,
    DRAWING,
    saveLocationBeforePolygon,
    setIsPolygonDrawing,
    setPolygonTogglerState,
    mapInstance,
    clearPolygon,
    markPolygonAction,
    getSavedLocation,
  ]);
};

export default useDrawable;
